<template>
  <div class="page custom-margin">
    <div id="cont" class="container">
      <div class="wrapper">
        <div class="title bg-primary "><span>Expense Request</span></div>
        <form @submit.prevent="makeRequest">
          <div class="row">
            <input type="Number" step="0.01" min="1" placeholder="Amount" v-model="form.amount" required>
          </div>
          <div class="row">
            <input type="text" placeholder="Reason" v-model="form.reason" required>
          </div>
          <div class="input-group mb-1">
            <div class="form-floating is-invalid">
              <VuePhoneNumberInput ref="tel" default-country-code="ZM" @update="updateNumber" v-model="fullInternational" />
            </div>
          </div>
              <div class="row">
            <button class="btn btn-primary">Submit</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
export default {
  name: "clientsside",
  components:{VuePhoneNumberInput},
  data() {
    return {
      show_password: false,
      fullInternational : "",
      isValidNum:false,
      form: {
        reason: "",
        amount: 0.00,
        recieversnumber: "" // Initialize with "" to ensure it starts with it
      }
    };
  },
  methods: {
    updateNumber(event){
      console.log(event)
      this.form.recieversnumber  = event.countryCallingCode + event.nationalNumber;
      this.isValidNum = event.isValid
    },
    makeRequest() {
      // Your existing makeRequest logic here
      console.log(this.form.recieversnumber)
      console.log(this.isValidNum)

      this.$utils.showLoading();
      if (this.isValidNum){
        return this.$store
            .dispatch(`makeExpenseRequest`, this.form)
            .then(() => {
              // Clear input values
              this.form.reason = "";
              this.form.amount = 0.00;
              this.fullInternational = ""; // Reset the phone number input value
            })
            .finally(() => this.$utils.hideLoading());
      } else {
        this.$utils.hideLoading()
        responses.showWarning(`Please Enter a valid number ! `)
        // Optionally, reset the phone number input value here if needed
        this.fullInternational = "";
      }
    },}
};
</script>
  
<style scoped lang="scss">
@import "../assets/css/styles";
</style>
<style>
.custom-input{
  width: 100px;
  height: 50px;
}
#cont{
  margin-top: 200px;
}
.page.custom-margin{
  margin-top: -100px!important;
}

</style>